import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from '../locales/en/common.json'
import enAuth from '../locales/en/auth.json'
import enLanding from '../locales/en/landing.json'
import enSurvey from '../locales/en/survey.json'
import enScoring from '../locales/en/scoring.json'
import enReport from '../locales/en/report.json'
import enAdmin from '../locales/en/admin.json'
import enManual from '../locales/en/manual.json'

import zhCommon from '../locales/zh-CN/common.json'
import zhAuth from '../locales/zh-CN/auth.json'
import zhLanding from '../locales/zh-CN/landing.json'
import zhSurvey from '../locales/zh-CN/survey.json'
import zhScoring from '../locales/zh-CN/scoring.json'
import zhReport from '../locales/zh-CN/report.json'
import zhAdmin from '../locales/zh-CN/admin.json'
import zhManual from '../locales/zh-CN/manual.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        landing: enLanding,
        survey: enSurvey,
        scoring: enScoring,
        report: enReport,
        admin: enAdmin,
        manual: enManual,
      },
      'zh-CN': {
        common: zhCommon,
        auth: zhAuth,
        landing: zhLanding,
        survey: zhSurvey,
        scoring: zhScoring,
        report: zhReport,
        admin: zhAdmin,
        manual: zhManual,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'landing', 'survey', 'scoring', 'report', 'admin', 'manual'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: { escapeValue: false },
  })

export default i18n
